export default __webpack_public_path__ + "static/media/decor9.2766484e.webp";